import { isNativeApp } from "@/lib/native";
import { SupportPage } from "@/router/SupportPage";

const PUBLIC_PATHS = ["/privacy", "/terms"];

function isPublicPath(pathname: string) {
  return PUBLIC_PATHS.some(p => pathname === p || pathname.startsWith(`${p}/`));
}

export function BrowserGuard({ children }: { children: React.ReactNode }) {
  if (import.meta.env.DEV || isNativeApp) {
    return <>{children}</>;
  }

  if (isPublicPath(window.location.pathname)) {
    return <>{children}</>;
  }

  if (window.location.pathname === "/") {
    return <SupportPage />;
  }

  window.location.replace("/");

  return null;
}
